import React from "react";

import { TextInput } from "@shared/text-input";

interface MetricSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const MetricSearch = ({ value, onChange }: MetricSearchProps) => {
  return (
    <TextInput
      className="w-48 mb-1 mx-4"
      placeholder="Search..."
      value={value}
      rightIcon={
        <i className="fa-regular fa-sharp fa-magnifying-glass text-cosmic" />
      }
      onChange={({ target }) => onChange(target.value)}
    />
  );
};
